/**
 * The credits gauge's tank size, shared by LeftSidebar and CreditBar.
 *
 * Peak-since-last-recharge when a recharge exists (the balance right after
 * that recharge). Welcome/invite grants never write last_recharge_amount, so
 * a never-recharged account sizes its tank by lifetime earnings instead; the
 * old hardcoded-1000 fallback made a fresh 500-credit invite account read
 * half-empty (2026-08-15). Clamped so the gauge never reads over-full, and
 * 1000 only when the account has no earnings signal at all.
 */
export function creditGaugeMax(
  balance: number,
  spentSinceRecharge: number,
  lastRechargeAmount: number,
  lifetimeEarned: number
): number {
  if (lastRechargeAmount > 0) {
    const peak = balance + spentSinceRecharge;
    if (peak > 0) return peak;
  }
  if (lifetimeEarned > 0) return Math.max(lifetimeEarned, balance);
  return Math.max(1000, balance);
}
